// Nss_heroimage_carousalinfo


// profile_info
 

const s1cover="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/s1cover.webp"
const s2cover="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/s2cover.webp"
const s3cover="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/s3cover.webp"
const s1="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/s1.webp"
const s2="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/s2.webp"
const s3="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/s3.webp"

// nssactivity

const gal1="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/nss/gal1.webp"
const gal2="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/nss/gal2.webp"
const gal3="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/nss/gal3.webp"
const gal4="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/nss/gal4.webp"
const gal5="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/nss/gal5.webp"
const gal6="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/nss/gal6.webp"
const gal7="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/cocurricular/nss/nss/gal7.webp"

const image1="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/nss/nsshero1.webp"
const image2="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/nss/nsshero2.webp"
const image3="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/nss/nsshero3.webp"
const image4="https://accet-site-media-trial.s3.ap-northeast-1.amazonaws.com/nss/nsshero4.webp"


const Nss_heroimage_carousalinfo = {
  id: 1,
  title: "National Service Scheme",
  img_list: [image1, image2, image3, image4],
};

const profile_info = [
  {
    id: "1",
    cover: s1cover,
    dp: s1,
    name: "Mr.S.Balasundar",
    Designation: "Assistant Professor (Mathematics)",
    mailid: "balasundaraccet@gmail.com",
  },
  {
    id: "2",
    cover: s2cover,
    dp: s2,
    name: "Dr.S.M.Sivagami",
    Designation: "Associate Professor (Mechanical)",
    mailid: "smsivagami@gmail.com",
  },
  {
    id: "3",
    cover: s3cover,
    dp: s3,
    name: " Dr.R.N.Mariammal",
    Designation: "Assistant Professor\n(Physics)",
    mailid: "marigayathrirn@gmail.com",
  },
];

export const nssachievements=[
  {
    id:1,
    heading:"2019-2020",
    component:"listformat",
    data:[
      {
        id: 1,
        point:
          "This college NSS unit received “award of appreciation” from AICTE, NEWDELHI for ONE STUDENT ONE TREE campaign from the MHRD Minister of India.",
      },
      {
        id: 2,
        point:
          "This college NSS Unit received “Swachch Bharat Summer Internship 2018” award with First Rank at Anna University, Chennai.",
      },
      {
        id: 3,
        point:
          "Selvan S.M. Mangalam BE Mech IV year and Selvi S. Aarthy, BE EEE III year received “Best NSS Volunteer award” at Anna University, Chennai",
      },
    ]
  },
  {
    id:2,
    heading:"2018-2019",
    component:"listformat",
    data:[
      {
        id:1 ,
        point:
          "Selvan S.A. Prasath, IV year EEE participated and performed well in “International Youth Exchange Programme” organized by Ministry of Youth Affairs and Sports, Govt of India, New Delhi from 02.04.2018 to 12.04.2018 at Nepal.",
      },
      {
        id:2 ,
        point:
          "66 NSS Volunteers participated in “Swachch Bharat Summer Intership Programme” from 13.07.2018 to 22.07.2018 at Palavangudi Village and Secured “First Prize” in Anna University level with cash prize Rs.30,000/-.",
      },
      {
        id:3 ,
        point:
          "Selvi S. Aarthi, III year EEE and Selvi S. Meena, III year EEE participated and trained well in NSS Adventure Camp for NSS Volunteers at Atal Bihari Vajpayee Institute of Mountaineering and Allied Sports, Manali from 28.10.2018 to 06.11.2018 sponsored by Ministry of Youth Affairs and Sports, Govt.of India, New Delhi.",
      },
      {
        id: 4,
        point:
          "Selvan S.A. Prasath and Selvi M. Sathiya Ruba awarded with “Best Volunteer Award” a University level award by Anna University, Chennai held on 28.09.2018.",
      },
      {
        id: 5,
        point:
          "Conducted National Integration Camp at this college from 10.12.2018 to 17.12.2018 funded by Ministry of Youth Affairs and Sports, Govt of India, New Delhi. 210 NSS Volunteers and 45 NSS Pos from 13 states participated in the camp",
      },
      {
        id: 6,
        point:
          "Vijayalakshmi and Ms K. Suganthi NSS Volunteers in the year 2011-2013 have been appointed as Sub Inspector of Police (Technical) by receiving additional marks in participation in NSS.",
      },
      {
        id: 7,
        point:
          "Received AICTE-SAGY award from AICTE, New Delhi for the work done in water management system at Palavangudi village on 21.01.2019.",
      },
      {
        id:8 ,
        point:
          "Selvan K. Karthikeyan, III year EEE participated in State level Republic Day Parade Camp at St.Fort George, Chennai in front of Chief Minister of Tamilnadu on 26.01.2019.",
      },
      {
        id: 9,
        point:
          "Conducted Special Camp from 11.03.2019 to 17.03.2019 at Palavangudi village and 180 NSS volunteers were participated in the camp.",
      },
      {
        id: 10,
        point:
          "Conducted “Swachch Bharat Mega Work Camp” from 11.03.2019 to 15.03.2019 at Palavangudi village and 100 volunteers from NSS Volunteers of ACGCET, APTC and SRRCET.      ",
      },
    ]
  },
  {
    id:3,
    heading:"2017-2018",
    component:"table",
    structure:{
      data:[
        {
          sno: "1",
          name: "K.T. Loganathan\n NSS PO",
          noa: "Best Programme Officer",
          issue: "NSS,Anna University,Chennai",
        },
        {
          sno: "2",
          name: "K.T. Loganathan\nNSS PO",
          noa: "Best Unit Award",
          issue: "NSS, Anna University, Chennai",
        },
        {
          sno: "3",
          name: "P. Pradeep",
          noa: "Best Volunteer Award",
          issue: "NSS, Anna University, Chennai",
        },
        {
          sno: "4",
          name: "S. Vignesh \n B.A.Jeyamurugan",
          noa: "First prize winner in documentary film",
          issue: "NSS, A.C. Tech, Anna University, Chennai-25",
        },
        {
          sno: "5",
          name: "M. Esakki ammal \nA. Anitha",
          noa: "First prize winner in poster presentation in “We- The volunteers” two days state level workshop",
          issue: "NSS, A.C. Tech, Anna University, Chennai-25",
        },
        {
          sno: "6",
          name: "S.M. Mangalam",
          noa: "First prize winner in poster presentation in “One day NSS social innovation symposium 2018”",
          issue:
            "NSS, BIT Campus, Anna University college of Engineering, Tiruchirappalli",
        },
        {
          sno: "7",
          name: "V. Sonia \n S. Gnanaharish",
          noa: "First prize winner in “art and paint event” One day NSS social innovation symposium 2018”",
          issue:
            "NSS, BIT Campus, Anna University college of Engineering, Tiruchirappalli",
        },
        {
          sno: "8",
          name: "S. Kavin",
          noa: "First prize winner in “Photography” One day NSS social innovation symposium 2018”",
          issue:
            "NSS, BIT Campus, Anna University college of Engineering, Tiruchirappalli",
        },
        {
          sno: "9",
          name: "P. Gayathri",
          noa: "First prize winner in “Group discussion event” One day NSS social innovation symposium 2018”",
          issue:
            "BIT Campus, Anna University college of Engineering, Tiruchirappalli",
        },
        {
          sno: "10",
          name: "P. Pradeep",
          noa: "First prize winner in Paper presentation in “One day NSS social innovation symposium 2018”",
          issue:
            "NSS, BIT Campus, Anna University college of Engineering, Tiruchirappalli",
        },
        {
          sno: "11",
          name: "B. Arthe",
          noa: "Second prize winner in “art and paint event” One day NSS social innovation symposium 2018”",
          issue:
            "NSS, BIT Campus, Anna University college of Engineering, Tiruchirappalli",
        },
        {
          sno: "12",
          name: "P. Moorthy",
          noa: "Best volunteer award for photography about “Swachch Bharat Mission” photo contest",
          issue: "Ministry of Drinking Water and Sanitation, New Delhi",
        },
      ],
      columns : [
        { field: "sno", header: "sno" },
        { field: "name", header: "name" },
        { field: "noa", header: "nature of the award" },
        { field: "issue", header: "issuing authority" },
      ]
    }
  }
]

const valaward = [
  {
    sno: 1,
    category:'University/+2 Council First Award',
    noa:'1',
    value:'Rs. 5,00,000/-',
  },
  {
    sno: 2,
    category:'Upcoming University Second Award',
    noa:'1',
    value:'Rs. 3,00,000/-',
  },
  {
    sno: 3,
    category:'Programme Officer',
    noa:'10',
    value:'Rs. 1,50,000/-',
  },
  {
    sno: 4,
    category:'NSS Unit',
    noa:'10',
    value:'Rs. 2,00,000/-',
  },
  {
    sno: 5,
    category:'NSS Volunteer',
    noa:'30',
    value:'Rs. 1,00,000/-',
  },
];



export const nssactivity=[
  gal1,gal2,gal3,gal4,gal5,gal6,gal7
]

export const activitylist = [
  {
    id:1,
    point:'National Integration Camp'
  },
  {
    id:2,
    point:'Blood Donation Camp'
  },
  {
    id:3,
    point:'Plantation'
  },
  {
    id:4,
    point:'Immunization'
  },
  {
    id:5,
    point:'Disaster Management'
  },
  {
    id:6,
    point:'Adventure Programmes'
  }
]

export {
  Nss_heroimage_carousalinfo,
  profile_info,
  valaward
};
